import * as React from "react";
import styled from "styled-components";
import { theme } from "styles/theme";
import { StyledImage } from "./styled";

type Props = Omit<
  React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >,
  "placeholder"
> & {
  placeholder?: React.ReactNode;
};

export default function Image(props: Props) {
  const { className, placeholder, style, ...rest } = props;
  const [hasError, setHasError] = React.useState(false);
  const [imgSrc, setImgSrc] = React.useState(rest.src);

  React.useEffect(() => {
    setImgSrc(rest.src);
    setHasError(false);
  }, [rest.src]);

  if (!imgSrc || hasError) {
    return (
      <SCon style={style} className={className}>
        {placeholder}
      </SCon>
    );
  }

  return (
    <SCon style={style} className={className}>
      <img 
        {...rest} 
        src={imgSrc}
        onError={() => setHasError(true)}
      />
    </SCon>
  );
}

const SCon = styled.div`
  width: 100px;
  height: 100px;
  flex: 0 0 auto;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${theme.border.light};
  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  font-size: 1.5em;
  overflow: hidden;
`;

// const Wrapper =
